import { Alert as AntAlert } from "antd";
import React from "reactn";

// Accepts both a string and an Error type.
export const ErrorMessage = ({ error }) => {
	if (!error) return null;
	const isString = typeof error === "string" || error instanceof String;
	const message = isString ? error : error.message;
	if (!message || typeof message !== "string" || message instanceof String)
		return null;

	if (process.env.NODE_ENV !== "production")
		return (
			<>
				<AntAlert description={message} type="error" />
				<pre>{JSON.stringify(error.debug, null, 2)}</pre>
			</>
		);
	return <AntAlert description={message} type="error" />;
};
